import Vue from 'vue'
import {BootstrapVue} from 'bootstrap-vue'
import "@/imports/datadog";
import '@/styles/main.scss'
import Api from './api'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { FontAwesomeLayers } from "@fortawesome/vue-fontawesome";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faReply, faSortUp, faSortDown, faUsers, faSearch, faPrint,faDotCircle, faCreditCard} from '@fortawesome/free-solid-svg-icons';
import { faCheck, faSignOutAlt, faExpandAlt, faCompressAlt, faMinusCircle, faEdit, faSave} from '@fortawesome/free-solid-svg-icons';
import {faExternalLinkAlt, faHouseUser, faAddressCard, faNewspaper, faUserCircle} from '@fortawesome/free-solid-svg-icons';
import {faCog, faQuestionCircle, faPoundSign, faShoppingBasket, faUndoAlt, faRedoAlt}  from '@fortawesome/free-solid-svg-icons';
import {faWrench, faChevronDown, faChevronUp, faChevronRight, faAngleRight, faExclamationCircle}  from '@fortawesome/free-solid-svg-icons';
import {faStar, faDownload, faSort, faFilter, faCommentSlash, faUser, faPhone, faEnvelope}  from '@fortawesome/free-solid-svg-icons';
import {faMapMarkerAlt, faChevronLeft, faCircle, faCheckCircle, faTimesCircle, faHourglassHalf}  from '@fortawesome/free-solid-svg-icons';
import {faArchive, faThumbsUp, faThumbsDown, faInfoCircle, faPlusCircle, faLock, faUserCheck, faLightbulb}  from '@fortawesome/free-solid-svg-icons';
import {faCloudUploadAlt, faTimes, faShareAlt, faBullhorn} from '@fortawesome/free-solid-svg-icons'
import { faTimesCircle as farTimesCircle, faBell, faPlusSquare, faMinusSquare, faCheckCircle as farCheckCircle} from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import abs from "@/imports/filters/abs";
import invoicePayment from "@/imports/filters/invoicePayment";
import parseDate from "@/imports/filters/parseDate";
import parseTime from "@/imports/filters/parseTime";
import parseDateTime from "@/imports/filters/parseDateTime";
import timescale from "@/imports/filters/timescale";
import parseDateTimeNs from "@/imports/filters/parseDateTimeNs";
import parseMonthVerbal from "@/imports/filters/parseMonthVerbal";
import truncate from "@/imports/filters/truncate";
import EventBus from "@/services/event"
import ClickOutside from "@/imports/directives/clickOutside"
import StripUrl from "@/imports/directives/stripUrl"
import * as VueGoogleMaps from 'vue2-google-maps'
import '@stripe/stripe-js';
import router from './../router';
import ErrorMessages from '@/services/errorMessages';
import VueAnalytics from "vue-analytics";
import "@/imports/validators";

library.add(faStar);
library.add(faDownload);
library.add(faSort);
library.add(faFilter);
library.add(faBell);
library.add(faCommentSlash);
library.add(faUser);
library.add(faPhone);
library.add(faEnvelope);
library.add(faMapMarkerAlt);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronDown);
library.add(faCheckCircle);
library.add(faTimesCircle);
library.add(faTimes);
library.add(faPoundSign);
library.add(faInfoCircle);
library.add(faPlusCircle);
library.add(faLock);
library.add(faExclamationCircle);
library.add(faCircle);
library.add(faHourglassHalf);
library.add(faArchive);
library.add(faThumbsUp);
library.add(faThumbsDown);
library.add(faSave);
library.add(faEdit);
library.add(faMinusCircle);
library.add(faCompressAlt);
library.add(faExpandAlt);
library.add(faAngleRight);
library.add(faShoppingBasket);
library.add(faCloudUploadAlt);
library.add(faChevronUp);
library.add(faWrench);
library.add(faUndoAlt);
library.add(faRedoAlt);
library.add(faHouseUser);
library.add(faAddressCard);
library.add(faNewspaper);
library.add(faUserCircle);
library.add(faCog);
library.add(faQuestionCircle);
library.add(faExternalLinkAlt);
library.add(faMinusSquare);
library.add(faPlusSquare);
library.add(faSignOutAlt);
library.add(faShareAlt);
library.add(faFacebook);
library.add(faTwitter);
library.add(faUserCheck);
library.add(farCheckCircle);
library.add(faCreditCard);
library.add(faDotCircle);
library.add(farTimesCircle);
library.add(faPrint);
library.add(faCheck);
library.add(faSearch);
library.add(faUsers);
library.add(faSortDown);
library.add(faSortUp);
library.add(faBullhorn);
library.add(faLightbulb);
library.add(faReply);

const gaId = process.env.VUE_APP_GA_ID;

Vue.use(VueAnalytics, {
  id: gaId,
  router,
  checkDuplicatedScript: true,
  autoTracking: {
    screenview: false,
    prependBase: true,
  },
  ecommerce: {
    enabled: true,
    enhanced: true
  },
});

Vue.use(BootstrapVue);
Vue.use(Api);
Vue.use(EventBus);
Vue.use(abs);
Vue.use(timescale);
Vue.use(parseTime);
Vue.use(parseDate);
Vue.use(parseDateTime);
Vue.use(parseDateTimeNs);
Vue.use(parseMonthVerbal);
Vue.use(truncate);
Vue.use(invoicePayment);
Vue.use(ClickOutside);
Vue.use(StripUrl);
Vue.use(ErrorMessages);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: 'geocoder', // This is required if you use the Autocomplete plugin
  },
});
